export const statusOptions = [
  { value: 'TO DO', label: 'TO DO' },
  { value: 'IN PROGRESS', label: 'IN PROGRESS' },
  { value: 'QA', label: 'QA' },
  { value: 'DONE', label: 'DONE' },
];

export const priorityOptions = [
  { value: 'P1', label: 'P1' },
  { value: 'P2', label: 'P2' },
  { value: 'P3', label: 'P3' },
  { value: 'P4', label: 'P4' },
];
